// Routes that are always accessible regardless of auth state.
// /invite/accept (REG-29): the invitee has no account yet, so requiring
// auth here would show them a login page for credentials they don't have.
// /signup (REG-177): same, for someone who has no org yet either.
// /find-workspace (REG-178): same, for someone who cannot remember which
// subdomain their account is on.
// /signup/email and /verify-email (REG-36): the password signup path
// alongside /signup's OAuth-only form, and the link it emails. Listed as
// exact strings, not prefixes of /signup, because the check below is a
// plain includes().
// /trial-expired (REG-37) is public for a specific reason: the user IS
// signed in, but every tenant-scoped call their session makes now comes
// back 423. Left out of this list, the gate would treat the failed auth
// check as "not authenticated" and render LoginPage instead of the pay
// wall -- and since login deliberately stays open for a locked org, the
// user would sign in, be bounced straight back here, and see the login
// form again. Short-circuiting before the auth check breaks that loop.
// /billing/pay (REG-46): Paddle's checkout link opens here. The transaction
// was fixed on the server, and the page must work without a session.
const PUBLIC_PATHS = [
  '/login',
  '/logout',
  '/status',
  '/invite/accept',
  '/signup',
  '/find-workspace',
  '/signup/email',
  '/verify-email',
  '/trial-expired',
  '/billing/pay',
]

// /status/<token> (REG-361): a workspace's public status page, same idea.
// /a/<token> (REG-56): the link in an SMS page. The responder is often
// signed out on their phone, and the token is the credential. A prefix,
// unlike the exact paths above, because the token is part of the path.
const PUBLIC_PREFIXES = ['/a/', '/status/']

export function isPublicPath(pathname: string): boolean {
  if (PUBLIC_PATHS.includes(pathname)) return true
  return PUBLIC_PREFIXES.some((prefix) => pathname.startsWith(prefix) && pathname.length > prefix.length)
}
